import { Header16, Header24, Header32, Header40, Paragraph16, SubHeader32 } from '../styles/typography'
import { SimpleLink } from '../components/atoms/link'
import styled from '@emotion/styled'
import { Footer } from '../components/atoms/footer'
import { Testimonials } from '../sections/Testimonials'
import { NavBar } from '../components/atoms/header'
import { HeroBackground, HeroContent, HeroMainHeader, ImageWrapper } from '../components/atoms/pageHero'
import heroImage from '../assets/images/projects/project3.jpg'
import { Contact } from '../sections/Contact'
import whiteLine from '../assets/images/vertical-line.png'
import profileImage from '../assets/images/about-portrait.png'
import { ProfileContainer, ProfileImageWrapper, TextContainer } from '../components/about'
import { Background, Card, CardWrapper, HeaderWrapper, MainContainer } from '../components/services'
import { projects } from '../projects'
import blueLine from '../assets/images/blue-line1.png'
import { useEffect } from 'react'

export function Services() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <NavBar />
            <HeroBackground>
                <HeroMainHeader>
                    <HeroContent>
                        <img src={whiteLine} style={{ height: '40px' }} />
                        <Header40 style={{ color: '#ffffff' }}>Services</Header40>
                    </HeroContent>
                </HeroMainHeader>
                <ImageWrapper src={heroImage} />
            </HeroBackground>

            <Background>
                <MainContainer>
                    <HeaderWrapper>
                        <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
                            <img style={{ height: '4px', width: '40px' }} src={blueLine} />
                            <SubHeader32 style={{ color: '#4E7BBC' }}>What We Do</SubHeader32>
                        </div>
                        <h2>Our Services</h2>
                        <Paragraph16 style={{ color: '#63665B', textAlign: 'justify' }}>
                            From structure to finish, we provide dependable construction services tailored to your
                            specific needs. Our commitment to craftsmanship and attention to detail means you can trust
                            JB Fine Line Construction to bring your vision to life.
                        </Paragraph16>
                    </HeaderWrapper>
                    <CardWrapper>
                        {projects.map((project, index) => (
                            <Card key={index} to={`/${project.id}`}>
                                <img style={{ width: '100%', height: '212px', objectFit: 'cover' }} src={project.img} />
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                    <h3>{project.title}</h3>
                                    <Paragraph16>{project.details}</Paragraph16>
                                </div>
                            </Card>
                        ))}
                    </CardWrapper>
                </MainContainer>
            </Background>

            <Testimonials />
            <Contact />
            <Footer />
        </div>
    )
}
